import React, { useRef, useEffect } from 'react'
// import Slider from '@material-ui/lab/Slider'
import AvatarEditor from 'react-avatar-editor'
import Typography from '@material-ui/core/Typography'

function getCanvasStyle() {
  return {
    margin: `1rem 30%`,
    maxWidth: `300px`,
  }
}

const CropLogo = ({
  imageSrc,
  onCrop,
  setEditorRef,
  scaleValue,
  onScaleChange,
  handleClose,
}) => {
  const [modalStyle] = React.useState(getCanvasStyle)
  const ref = useRef(null)

  useEffect(() => {
    setEditorRef(ref)
  }, [ref])

  if (!imageSrc) return null
  return (
    <div style={modalStyle}>
      <AvatarEditor
        ref={ref}
        image={imageSrc}
        scale={scaleValue}
        width={200}
        height={200}
        border={20}
        borderRadius={200}
        color={[255, 255, 255, 0.6]} // RGBA
        rotate={0}
      />
      <Typography id="discrete-slider" gutterBottom>
        zoom
      </Typography>

      <input
        style={{ width: '100%', marginTop: '1rem' }}
        type="range"
        value={scaleValue}
        min="1"
        max="10"
        onChange={onScaleChange}
      />
      <button
        style={{
          // marginLeft: '2rem',
          cursor: 'pointer',
          border: 'none',
          backgroundColor: '#FFFFFF',
          borderRadius: 20,
          color: `rgba(0, 0, 0, 0.87)`,
          padding: `6px 16px`,
          fontStyle: `bold`,
          fontSize: `0.875rem`,
        }}
        onClick={handleClose}
      >
        Cancel
      </button>

      <button
        style={{
          marginLeft: '5rem',
          marginTop: '1rem',
          cursor: 'pointer',
          border: 'none',
          backgroundColor: '#FFFFFF',
          color: '#00A1E4',
          padding: '5px 16px',
          borderRadius: 20,
          left: '75%',
          textAlign: 'center',
        }}
        onClick={onCrop}
      >
        Crop
      </button>
    </div>
  )
}

export default CropLogo



// WEBPACK FOOTER //
// ./src/components/crop/CropLogo.js